//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

/**
 * Internal class representing a PhoneNumberEntry in the PhoneNumbers array in the DGI v1 grammar.
 */
export interface PhoneNumberEntry {
    /**
     * Gets a PhoneNumber in the PhoneNumbers array
     */
    phoneNumber: string;
}
